import * as React from "react";

import { Grid } from "@material-ui/core";
import Breadcrumb from "../components/breadcrumb";
import { fixToPersianNumbers, numberWithCommas } from "../../../utils/helpers";
import classes from './index.module.scss';
import Pictures from "../components/pictures";
import { useHistory, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import CategoryHeader from "../components/categoriesHeader";
import ProductRepository from "client-sdk/src/Repository/product-repository";
import Headers from "../components/header";
import handleError from "../../../utils/handleError";

const SingleProduct = (props: any) => {
  let { id } = useParams()
  const navigate = useHistory()
  const [added, setAdded] = React.useState(false)
  const [product, setProduct] = useState(null)
  const [categories, setCategories] = React.useState([])
  const [images, setImages] = React.useState([]);



  useEffect(() => {
    getProduct()
    getCategory()
  }, [])

  useEffect(() => {
    if (product?.imageNames) {
      getImages()
    }
  }, [product])


  const getCategory = async () => {
    const category = await ProductRepository.getVitrinCategories({});
    setCategories(category?.data)
  }

  const getProduct = async () => {
    const response = await ProductRepository.getVitrinProductWithId({ payload: { id } })
    setProduct(response?.data)
    const select = await ProductRepository.getVitrinSelectedProduct({ payload: { 'productId.equals': id } })
    if (select?.data[0]?.id == id) {
      setAdded(true)
    }
  }

  const addToFavariot = async () => {
    const response = await ProductRepository.selectVitrinProduct({ payload: { id: product.id } })
    if (response) {
      setAdded(true)
    }
  }

  const removeFromFavariot = async () => {
    const response = await ProductRepository.unSelectVitrinProduct({ payload: { id: product.id } })
    if (response) {
      setAdded(false)
    }
  }
  const changeCategory = (cat: string) => {
    navigate.push(`/vitrin/products?categoryId.equals=${cat}`)
  }

  const getImages = async () => {
    const imagesList: string[] = []
    try {
      product?.imageNames?.forEach(async (prod: any) => {
        if (prod) {
          const image = await ProductRepository.getImagefromVitrin({ payload: { id, fileName: prod } });
          imagesList.push(image.data)
          setImages(imagesList)
        }
      });
    } catch (err) {
      handleError(err)
    }
  }

  return (
    <>
      <Headers />
      <div className="container bg-white pb-5">
        <CategoryHeader categories={categories} changeCategory={changeCategory} />
        {/* <Breadcrumb/> */}
        <Grid container className="px-5 products-container">
          <Grid lg={4}>
            <Pictures images={images} />
          </Grid>
          <Grid lg={4}>
            <h3>{product?.name}</h3>
            <hr className="hr" />
            <h2>{fixToPersianNumbers(numberWithCommas(`${product?.price}`))} <span className="text-muted text-sm">تومان</span></h2>
            <hr className="hr" />
            <p>{product?.description}</p>
          </Grid>
          <Grid lg={4}>
            <div className={classes.actionBox}>
              <p className="mx-5 text-normal">موجودی: {
                product?.inventoryDTO === null || product?.inventoryDTO.orderAble === null ? 0 : fixToPersianNumbers(`${product?.inventoryDTO?.orderAble}`)
              }
                {' '}عدد </p>
              <hr className="hr" />
              <p className="mx-5">برای ثبت سفارش روی این کالا آن را به لیست کالاهای منتخب خود اضافه کنید.
                لیست کالاهای منتخب خود را می‌توانید در پنل روناد بخش کالاها مشاهده کنید</p>
              <div className="text-center mb-4">
                {!added && <button className="btn-secondary" onClick={addToFavariot}>افزودن به لیست کالاهای منتخب</button>}
                {added && <button className="btn-yellow-outline" onClick={removeFromFavariot}>حذف از کالاهای منتخب</button>}
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  )
}

export default SingleProduct;